import { render } from "./RangeSelection.vue?vue&type=template&id=5c268be1"
import script from "./RangeSelection.vue?vue&type=script&lang=ts"
export * from "./RangeSelection.vue?vue&type=script&lang=ts"
script.render = render

export default script